import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthComponent} from './modules/auth/auth.component';
import {AdminComponent} from './modules/admin/admin.component';
import {NotFoundComponent} from "./modules/auth/pages/not-found/not-found.component";
import { MidianitasRedirectComponent } from './redirects/midianitas/midianitas-redirect.component';

const routes: Routes = [
  {
    path: 'midianitas',
    component: MidianitasRedirectComponent
  },
  {
    path: 'admin',
    component: AdminComponent,
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: '',
    component: AuthComponent,
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    redirectTo: '/presentation',
    pathMatch: 'full'
  }, {
    path: '**',
    redirectTo: '/presentation',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
